import { createRoot } from "react-dom/client";
import "../index.css";
import { showPopupAlertFromLocalStorage } from "../components/alerts/popup-alert.tsx";
import { LoginDialogContextProvider } from "./utils/login-dialog-context.tsx";
import { LoginConfigProvider } from "./utils/login-config-context.tsx";
import { UserLoginSignUpDialog } from "./user-login-sign-up-dialog.tsx";
import { ContextsBootstrap } from "../utils/contexts-bootstrap.tsx";

const dialogRootContainer = document.createElement("div");
dialogRootContainer.id = "login-dialog-root";
document.body.appendChild(dialogRootContainer);
const reactRoot = createRoot(dialogRootContainer);

// show any alerts that were saved to local storage
showPopupAlertFromLocalStorage();

reactRoot.render(
  <ContextsBootstrap contexts={[<LoginConfigProvider />, <LoginDialogContextProvider />]}>
    <UserLoginSignUpDialog
      loginTriggerElementSelector=".navbar-login-btn"
      signUpTriggerElementSelector=".navbar-sign-up-btn"
    />
  </ContextsBootstrap>,
);
